import {HttpClient} from "../core/HttpClient";
import {Config} from "../../Config";

export const Login = (email, password) => {
    return HttpClient.post(`${Config.APPURL}/auth`, {
        'email' : email,
        'password' : password,
    })
}